Object.defineProperty(exports, "__esModule", { value: true });
exports.salseData = [
  { x: "USD", y: 70, text: " USD: 30%" },
  { x: "SIKI Coins", y: 110, text: "SIKI Coins: 10%" },
  { x: "Polygon", y: 40, text: "Polygon: 75%" },
  { x: "Currency 4", y: 50, text: "Currency 4: 30%" },
  { x: "Currency 5", y: 90, text: "Currency 5: 4%" },
];
